export const storage = {
  get(key: string): string {
    return localStorage.getItem(key) || "";
  },
  set(key: string, val: string): void {
    return localStorage.setItem(key, val);
  },
  setObj(key: string, val: any): void {
    localStorage.setItem(key, val && JSON.stringify(val));
  },
  getObj(key: string): unknown {
    let result = localStorage.getItem(key);
    if (result === "undefined") {
      console.log(key + "数据未定义");
      return result;
    }
    if (result) {
      try {
        result = JSON.parse(result);
      } catch (e) {
        console.log("获取数据错误,不能被parse");
      }
    }
    return result;
  },
  remove(key: string) {
    localStorage.removeItem(key);
  },
  clear(): void {
    localStorage.clear();
  },
};
export const session = {
  get(key: string): string {
    return sessionStorage.getItem(key) || "";
  },
  getObj(key: string): object {
    const obj = sessionStorage.getItem(key) || "{}";
    return JSON.parse(obj);
  },
  set(key: string, val: string | object): void {
    let temp = "";
    if (isObject(val)) {
      temp = JSON.stringify(val);
    } else {
      temp = val as string;
    }

    return sessionStorage.setItem(key, temp);
  },
};

function isObject(value: any) {
  return (
    value != null && (typeof value === "object" || typeof value === "function")
  );
}
